document.addEventListener('DOMContentLoaded', function () {

  // =============================================
  // 祝日リスト（毎年1月頃に翌年分を追加）
  // 参考: https://www8.cao.go.jp/chosei/shukujitsu/gaiyou.html
  // =============================================
  const HOLIDAYS = [
    '2026-01-01', // 元日
    '2026-01-12', // 成人の日
    '2026-02-11', // 建国記念の日
    '2026-02-23', // 天皇誕生日
    '2026-03-20', // 春分の日
    '2026-04-29', // 昭和の日
    '2026-05-03', // 憲法記念日
    '2026-05-04', // みどりの日
    '2026-05-05', // こどもの日
    '2026-07-20', // 海の日
    '2026-08-11', // 山の日
    '2026-09-21', // 敬老の日
    '2026-09-22', // 国民の日
    '2026-09-23', // 秋分の日
    '2026-10-12', // スポーツの日
    '2026-11-03', // 文化の日
    '2026-11-23', // 勤労感謝の日
    '2027-01-01', // 元日
    '2027-01-11', // 成人の日
    '2027-02-11', // 建国記念の日
    '2027-02-23', // 天皇誕生日

    '2026-08-12','2026-08-13','2026-08-14', // 夏季休暇
    '2026-08-31', // 夏季棚卸し
    '2026-12-29','2026-12-30','2026-12-31','2027-01-01','2027-01-04', // 冬季休暇
  ];

  // =============================================
  // 指定日が営業日かどうかを判定
  // 土曜(6)・日曜(0)・祝日はfalseを返す
  // =============================================
  function isBusinessDay(date) {
    const ymd = date.toLocaleDateString('sv-SE', { timeZone: 'Asia/Tokyo' }); // 'YYYY-MM-DD'形式
    const dow = new Date(ymd).getDay(); // 0=日, 6=土
    return dow !== 0 && dow !== 6 && !HOLIDAYS.includes(ymd);
  }

  // =============================================
  // 発送予定日を計算する
  // days=0: 当日発送, days=1: 翌営業日, days=3: 3営業日後
  // 12時以降 or 今日が非営業日の場合は翌営業日スタート
  // =============================================
  function calcShippingDate(days) {
    const now = new Date();

    // JSTの現在時刻（時）を取得
    const jstHour = parseInt(now.toLocaleString('ja-JP', {
      timeZone: 'Asia/Tokyo', hour: 'numeric', hour12: false
    }));

    // スタート日を決定
    // 12時以降 or 非営業日なら翌営業日まで進める
    let date = new Date(now);
    if (jstHour >= 12 || !isBusinessDay(date)) {
      do { date.setDate(date.getDate() + 1); } while (!isBusinessDay(date));
    }

   // スタート日を1日目として、days分の営業日を加算
　// days=0: 当日発送, days=1: 翌営業日, days=3: 3営業日目  ← ここを修正

    let count = 1;
    while (count < days) {
      date.setDate(date.getDate() + 1);
      if (isBusinessDay(date)) count++;
    }
    return date;
  }

  // =============================================
  // 日付を「7月10日（金）」形式にフォーマット
  // =============================================
  function fmt(date) {
    return date.toLocaleDateString('ja-JP', {
      timeZone: 'Asia/Tokyo', month: 'long', day: 'numeric', weekday: 'short'
    });
  }

  // =============================================
  // 表示処理
  // Liquidで出力した data-days / data-days-engraving を読み取り
  // 条件を満たす行だけテーブルとして描画する
  // =============================================
  const el = document.getElementById('shipping-estimate');
  if (!el) return; // 要素がなければ終了（メタフィールド未設定商品）

  const d = parseInt(el.dataset.days);           // 通常発送日数
  const de = parseInt(el.dataset.daysEngraving); // 名入れ発送日数
  let rows = '';

  // 通常日数が設定されている場合（0=即日も含む）
  if (d >= 0 && !isNaN(d))  rows += `<tr><td>🚚 通常</td><td><strong>${fmt(calcShippingDate(d))}</strong> 頃</td></tr>`;

  // 名入れ日数が設定されている場合（0=即日も含む）
  if (de >= 0 && !isNaN(de)) rows += `<tr><td>✏️ 名入れあり</td><td><strong>${fmt(calcShippingDate(de))}</strong> 頃</td></tr>`;

  // 行があれば描画、なければ何も表示しない
  if (rows) el.innerHTML = `<table class="shipping-estimate__table">${rows}</table>`;

});
